__turbopack_context__.v({
  "actionButton": "ActionWrapper-module-scss-module__cbjWDa__actionButton",
  "actionLink": "ActionWrapper-module-scss-module__cbjWDa__actionLink",
});
